import $ from 'jquery';

const selectDropdownV1Semantics = {
    mainWrapClass: 'select-dropdown-v1',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    elementClass: 'select-dropdown-v1__container',
    dropdownContainer: 'select-dropdown-v1__dropdown-container',
    activeElementClass: 'select-dropdown-v1__item-active',
    elementItem: 'select-dropdown-v1__item',
    elementOpenClass: 'select-dropdown-v1__open',
}

$(function () {

    let roots = $(`.${selectDropdownV1Semantics.mainWrapClass}`);
    if (roots.length === 0) {
        return false;
    }
    let selectDropdownV1 = new SelectDropdownV1();
    /**
     * Checking other instances
     */
    $('body').click(function(e){
            $(`.${selectDropdownV1Semantics.elementOpenClass}`).each(function(index,n){
                let state = $(n).attr('data-init');
                if(state === "1") {
                    $(n).attr('data-init',0);
                }
                else{
                    SelectDropdownV1.detach($(n));
                }
            });
    });

    roots.each((index, el) => {
        let isInitialized =
            ($(el).attr(`${selectDropdownV1Semantics.isInitializedAttribute}`) === 'true');

        if (!isInitialized) {
            selectDropdownV1.registerInstance($(el));
            selectDropdownV1.registerListeners($(el));
        }
    });
})

class SelectDropdownV1 {

    constructor() {
        this.pluginInstances = {};
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${selectDropdownV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        try {
            let object = el.find(`.${selectDropdownV1Semantics.mainWrapClass}`);
            el.attr(`${selectDropdownV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch(e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el)
    {
        let instance = this;
        let elements = $(`.${selectDropdownV1Semantics.mainWrapClass}[${
            selectDropdownV1Semantics
                .instanceIdAttribute
        }="${
            el.attr(selectDropdownV1Semantics
                .instanceIdAttribute)
        }"]`);
        elements.on(
            'click',
            `.${selectDropdownV1Semantics.elementClass}`,
            function(e) {
                let current = $(e.currentTarget);
                current.toggleClass(selectDropdownV1Semantics.elementOpenClass);
                if(current.hasClass(selectDropdownV1Semantics.elementOpenClass)) {
                    instance.createWidgetDomList(current);
                    current.attr('data-init',1);
                }
                else{
                    SelectDropdownV1.detach(current);
                }
            }
        );
    }

    createWidgetDomList(current) {
        let options = [];
        current.parent().find('option').each(function(index, n){
            let active = $(n).attr('selected') === 'selected' ?  ` ${selectDropdownV1Semantics.activeElementClass}` : '';
            let b = $(n);
            options.push(`<li class="${selectDropdownV1Semantics.elementItem}${active}">
                    <a href="${b.attr('data-href')}">${b.text()}</a>
            </li>`);
        });
        current.append(`<div class="${selectDropdownV1Semantics.dropdownContainer}"><div><ul>${options.join('')}</ul></div></div>`);
    }

    static detach(el) {
        el.find(`.${selectDropdownV1Semantics.dropdownContainer}`).detach();
        el.removeClass(selectDropdownV1Semantics.elementOpenClass);
    }
}

export default SelectDropdownV1;